<template>
  <div>
    <div>
      <ProductRadioButtons
        v-if="options.length >= 1"
        :default-val="defaultValue"
        :options="options"
        :hide-border="true"
        @radio-value-changed="handleOptionChanged($event)"
      />
    </div>
  </div>
</template>
<script>
import ProductRadioButtons from "./ProductRadioButtons.vue";
export default {
  name: "ProductOptionSelectorAlt",
  components: {
    ProductRadioButtons
},
  props: {
    optionsObject: Object,
  },
  data() {
    return {
      options: this.deriveOptions(),
      defaultValue: this.getDefaultValue()
    };
  },
  methods: {
    handleOptionChanged(value) {
      const selectedOption = this.optionsObject.options.find((option) => ([option.text, option.size].join(' ') + '"') == value)
      if (selectedOption && selectedOption.slug) {
        const splitPath = window.location.pathname.split('/')
        splitPath[splitPath.length - 1] = selectedOption.slug
        window.location.assign(splitPath.join('/'))
      }
    },
    deriveOptions() {
      return this.optionsObject.options.map((option) => [option.text, option.size].join(' ') + '"');
    },
    getDefaultValue() {
      const selected = this.optionsObject.options.find((option) => option.selected) 
      return [selected.text, selected.size].join(' ') + '"'
    }
  },
};
</script>
<style scoped>
.shipping_length {
  font-weight: 600;
  font-size: 14px;
  padding: 10px 20px;
  border: 1px solid #cbc8c3;
  background-color: #f2f2f2;
  border-radius: 10px;
  display: inline-block;
}
</style>
